module.exports = __webpack_public_path__ + "static/media/quindio-50.a2b1afcc.jpg";